import ReservationReportIndex from "@/views/report/reservation/ReservationReportIndex.vue";
import ReservationReportPrint from "@/views/report/reservation/ReservationReportPrint.vue";

const reservationReport = [
  {
    path: "/reservation-report",
    name: "reservation-report",
    component: ReservationReportIndex,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
  {
    path: "/reservation-report/print",
    name: "reservation-report-print",
    component: ReservationReportPrint,
    meta: {
      layout: "print",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
];

export default reservationReport;
